import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { HttpClient } from '@angular/common/http';
import { requestWithFallback } from '../http/request-with-response';

import * as Sentry from "@sentry/angular";

@Injectable()
export class VersionService {

  private readonly version_key = "site_version";
  constructor(private readonly http: HttpClient) {
    localStorage.removeItem(this.version_key);
  }

  getVersion() {
    const fallback = {version: 'Versión no disponible.'};
    return requestWithFallback<any>(this.http.get(`${environment.apiURLs.public}/version`), fallback, response => {
      localStorage.setItem(this.version_key, JSON.stringify(response));
      Sentry.setContext('app', { version: response || 'desconocido' });
    }).then(response => {
      if (response === fallback) localStorage.setItem(this.version_key, JSON.stringify(fallback));
      return response;
    });
  }
}
